import "./Complaint.css";
import { ImCancelCircle } from "react-icons/im";
import CustomButton from "../customButton/CustomButton";
import { useAddComplainMutation } from "../../store/query/applicants";
import { useTypedSelector } from "../../hook/useTypedSelector";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";

const initial = {
  comment: "",
};

const validate = Yup.object({
  comment: Yup.string()
    .trim()
    .min(1, "Comment cannot be empty")
    .required("Comment is required"),
});

const ComplaintModal = ({ close, setTag, appId, details, manageRefetch }) => {
  const { user } = useTypedSelector((store) => store.appUser);
  const [addComplain, { isLoading }] = useAddComplainMutation();

  const {
    values,
    handleChange,
    handleBlur,
    touched,
    handleSubmit,
    errors,
    isSubmitting,
  } = useFormik({
    initialValues: initial,
    validationSchema: validate,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      const res = await addComplain({
        type: user?.account_type,
        job_id: details.job_id,
        applicant_id: appId,
        applicant_account_type: details.app_type,
        comment: values.comment,
      });

      console.log("res", res);

      if (res.data.status) {
        toast.success(res.data.message ?? "Complain Created Successfully");
        resetForm();
        close();
        await manageRefetch();
        setTag(3);
      }
    },
  });

  return (
    <div className="complaint-modal-container">
      <ImCancelCircle className="icon-can" onClick={close} />
      <div className="complaint-modal-content">
        <div className="header">
          <h4>File a complaint</h4>
        </div>
        <div className="main-content">
          <div className="text-field">
            <textarea
              name="comment"
              value={values.comment}
              onChange={handleChange}
              onBlur={handleBlur}
              cols="10"
              rows="5"
              placeholder="Write a complaint"
              disabled={isLoading || isSubmitting}
              className={touched.comment && errors.comment ? "input-error" : ""}
            />
            {touched.comment && errors.comment && (
              <div className="error-message">{errors.comment}</div>
            )}
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              marginTop: "5px",
            }}
          >
            <CustomButton
              customStyles={{
                marginTop: "10px",
                width: "30%",
                height: "40px",
                fontSize: "16px",
                borderRadius: "5px",
              }}
              disable={isLoading || isSubmitting}
              loading={isLoading || isSubmitting}
              title="Submit"
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplaintModal;
